import * as React from 'react'
import { defineMessages, FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import styles from './faq.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: 'FAQ - Dina frågor besvarade',
    id: 'diy-payroll.faq.heading',
  },
  question1: {
    defaultMessage: 'Kostar det något att använda Dooer lön?',
    id: 'diy-payroll.faq.question-1',
  },
  answer1: {
    defaultMessage:
      'Dooer lön, precis som vårt fakturerings- och bokföringsprogram, är helt gratis och kommer alltid att vara det.',
    id: 'diy-payroll.faq.answer-1',
  },
  question2: {
    defaultMessage: 'Är Dooer lön integrerat med Dooer bokföring?',
    id: 'diy-payroll.faq.question-2',
  },
  answer2: {
    defaultMessage:
      'Ja, Dooer lön är fullt integrerat med din bokföring och löner bokförs automatiskt. Dessutom skapas AGI-rapporter automatiskt och skickas med ett klick in till Skatteverket direkt från Dooer.',
    id: 'diy-payroll.faq.answer-2',
  },
  question3: {
    defaultMessage: 'Hur många anställda kan jag ha?',
    id: 'diy-payroll.faq.question-3',
  },
  answer3: {
    defaultMessage:
      'Det finns inga begränsningar på antal anställda och du skickar hur många lönebesked du vill. Så länge du vill och alltid helt gratis.',
    id: 'diy-payroll.faq.answer-3',
  },
  question4: {
    defaultMessage: 'Kan jag lägga till semesterdagar?',
    id: 'diy-payroll.faq.question-4',
  },
  answer4: {
    defaultMessage:
      'Ja, i Dooer lägger du enkelt till semesterdagar när du lägger till dina anställda. Sedan räknar Dooer automatiskt ut tillgängliga dagar för respektive anställd.',
    id: 'diy-payroll.faq.answer-4',
  },
})

const qas = [
  {
    q: messages.question1,
    a: messages.answer1,
  },
  {
    q: messages.question2,
    a: messages.answer2,
  },
  {
    q: messages.question3,
    a: messages.answer3,
  },
  {
    q: messages.question4,
    a: messages.answer4,
  },
]

export default function Faq() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <FormattedHTMLMessage tagName="h2" {...messages.heading} />
        <div className={styles.items}>
          {qas.map((item) => (
            <div key={item.q.defaultMessage}>
              <FormattedMessage tagName="h4" {...item.q} />
              <FormattedMessage tagName="p" {...item.a} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
